import { Component, OnInit } from '@angular/core';
declare const $;
@Component({
  selector: 'app-server-under-maintanance',
  templateUrl: './server-under-maintanance.component.html',
  styleUrls: ['./server-under-maintanance.component.css']
})
export class ServerUnderMaintananceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $("#preloader").css('display','none');
  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/server-under-maintanance/server-under-maintanance.component.ts